import React, { useState } from 'react';
import CalendlyButton from './CalendlyButton';
import './Skills.css';

const Skills = () => {
  const [expandedSections, setExpandedSections] = useState({
    technical: true,
    leadership: true,
    methodologies: true,
    technologies: true // Default to expanded
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const technicalSkills = [
    // Content to be filled in later
  ];

  const leadershipSkills = [
    // Content to be filled in later
  ];

  const methodologies = [
    // Content to be filled in later
  ];

  const technologies = [
    // Content to be filled in later
  ];

  return (
    <section id="skills" className="skills">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Skills & Expertise</h2>
          <p className="section-subtitle">
            Content to be filled in later
          </p>
        </div>

        <div className="skills-content">
          <div className="skills-section">
            <div className="skills-section-header" onClick={() => toggleSection('technical')}>
              <h3>Technical Skills</h3>
              <span className="expand-icon">{expandedSections.technical ? '−' : '+'}</span>
            </div>
            {expandedSections.technical && (
              <div className="skills-grid">
                {technicalSkills.length > 0 ? (
                  technicalSkills.map((skill, index) => (
                    <div key={index} className="skill-item">
                      <div className="skill-header">
                        <span className="skill-icon">{skill.icon}</span>
                        <span className="skill-name">{skill.name}</span>
                        <span className="skill-level">{skill.level}%</span>
                      </div>
                      <div className="skill-bar">
                        <div 
                          className="skill-progress" 
                          style={{ width: `${skill.level}%` }}
                        ></div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p style={{ textAlign: 'center', color: '#e8e8e8', padding: '2rem' }}>
                    Content to be filled in later
                  </p>
                )}
              </div>
            )}
          </div>

          <div className="skills-section">
            <div className="skills-section-header" onClick={() => toggleSection('leadership')}>
              <h3>Leadership & Soft Skills</h3>
              <span className="expand-icon">{expandedSections.leadership ? '−' : '+'}</span>
            </div>
            {expandedSections.leadership && (
              <div className="skills-grid">
                {leadershipSkills.length > 0 ? (
                  leadershipSkills.map((skill, index) => (
                    <div key={index} className="skill-item">
                      <div className="skill-header">
                        <span className="skill-icon">{skill.icon}</span>
                        <span className="skill-name">{skill.name}</span>
                        <span className="skill-level">{skill.level}%</span>
                      </div>
                      <div className="skill-bar">
                        <div 
                          className="skill-progress" 
                          style={{ width: `${skill.level}%` }}
                        ></div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p style={{ textAlign: 'center', color: '#e8e8e8', padding: '2rem' }}>
                    Content to be filled in later
                  </p>
                )}
              </div>
            )}
          </div>

          <div className="skills-section">
            <div className="skills-section-header" onClick={() => toggleSection('methodologies')}>
              <h3>Development Methodologies</h3>
              <span className="expand-icon">{expandedSections.methodologies ? '−' : '+'}</span>
            </div>
            {expandedSections.methodologies && (
              <div className="methodologies-grid">
                {methodologies.length > 0 ? (
                  methodologies.map((methodology, index) => (
                    <div key={index} className="methodology-card">
                      <span>{methodology}</span>
                    </div>
                  ))
                ) : (
                  <p style={{ textAlign: 'center', color: '#e8e8e8', padding: '2rem' }}>
                    Content to be filled in later
                  </p>
                )}
              </div>
            )}
          </div>

          <div className="skills-section">
            <div className="skills-section-header" onClick={() => toggleSection('technologies')}>
              <h3>Technologies & Tools</h3>
              <span className="expand-icon">{expandedSections.technologies ? '−' : '+'}</span>
            </div>
            {expandedSections.technologies && (
              <div className="technologies-grid">
                {technologies.length > 0 ? (
                  technologies.map((technology, index) => (
                    <div key={index} className="technology-card">
                      <span>{technology}</span>
                    </div>
                  ))
                ) : (
                  <p style={{ textAlign: 'center', color: '#e8e8e8', padding: '2rem' }}>
                    Content to be filled in later
                  </p>
                )}
              </div>
            )}
          </div>
          
          <div className="calendly-button-section">
            <CalendlyButton />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;

